import React, { Fragment, useEffect } from "react";
import Breadcrumb from "../../components/Admin/Reusable/Breadcrumb";
import ButtonColumn from "../../components/Admin/Reusable/ButtonColumn";
import { statusRender } from "../../utils/cellRenderTable";
import AggridTable from "../../components/Admin/Reusable/AggridTable";
import { useDispatch, useSelector } from "react-redux";
import { deleteItem, fetchQaPagesList } from "../../actions/Admin/qa";

const QaList = () => {
  const dispatch = useDispatch();

  const { dataPagesList } = useSelector((state) => state.qaReducer);

  useEffect(() => {
    dispatch(fetchQaPagesList());
  }, [dispatch]);

  //akcija brisanja iz liste
  const handleSubmitModal = (pageId) => {
    dispatch(deleteItem(pageId));
  };

  const customCellRenderer = (params) => (
    <ButtonColumn
      editLink={`/adminManager/qa-edit/` + params.data.anId}
      deleteItemId={params.data.anId}
      deleteItemTitle={params.data.acTitle}
      value={params}
      submitActionModal={handleSubmitModal}
    />
  );

  //settings za tabelu
  const columnDefs = [
    { headerName: "ID", field: "anId", filter: true, width: 100 },
    {
      headerName: "Naslov",
      field: "acTitle",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 250,
    },
    { headerName: "Kategorija", field: "acCategoryName", filter: true },
    { headerName: "Jezik", field: "acLanguageName", filter: true },
    {
      headerName: "Status",
      field: "acStatusName",
      filter: "agTextColumnFilter",
      cellRenderer: statusRender,
      width: 150,
    },
    {
      headerName: "Kreirao",
      field: "ins_acUsername",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Izmenio",
      field: "edit_acUsername",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Datum kreiranja",
      field: "adTimeIns",
      filter: "agDateColumnFilter",
    },
    {
      headerName: "Datum izmene",
      field: "adTimeUpd",
      filter: "agDateColumnFilter",
    },
    {
      headerName: "Panel",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 120,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb title="Pregled pitanja" type="qa-lista" />
      <AggridTable rowData={dataPagesList} columnDefs={columnDefs} />
    </Fragment>
  );
};

export default QaList;
